module.exports = __webpack_public_path__ + "static/media/placeholder01.2a6c222b.jpg";